export default {
  "content": "<path d=\"M11.251 4.723a.5.5 0 01.89.435l-1.53 4.588 3.613 1.807a.501.501 0 01.192.724l-4.667 7a.5.5 0 01-.89-.435l1.529-4.59-3.612-1.805a.501.501 0 01-.192-.724l4.667-7z\" fill=\"#7B61FF\"/><path d=\"M8 7H4a1 1 0 00-1 1v8l.005.102A1 1 0 004 17h3v2H4a3 3 0 01-2.996-2.846L1 16V8a3 3 0 013-3h4v2zM17 5a3 3 0 013 3v8a3 3 0 01-3 3h-4v-2h4a1 1 0 001-1V8a1 1 0 00-1-1h-3V5h3zM23.5 14.5h-2v-5h2v5z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};